module.exports = __webpack_public_path__ + "static/media/4.38aa7cb7.png";